import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const CancellationPolicyPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Quick Support Button - Fixed Position */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="bg-white rounded-full shadow-lg border border-gray-200 p-1">
          <div className="flex space-x-2">
            <a
              href="mailto:info@revisableapp.com"
              className="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full transition-all duration-300 hover:scale-110 shadow-lg hover:shadow-xl group"
              title="Email Support"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
            <a
              href="https://wa.me/919650500689"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full transition-all duration-300 hover:scale-110 shadow-lg hover:shadow-xl group"
              title="WhatsApp Support"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.512z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center">
              <img 
                src="/images/logo.png" 
                alt="Residency Companion Logo" 
                className="w-10 h-10 mr-4 object-contain"
              />
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
                Residency Companion
              </h1>
            </Link>
            <div className="flex items-center space-x-1">
              <Link 
                to="/login"
                className="text-gray-600 hover:text-gray-900 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:bg-gray-50"
              >
                Sign In
              </Link>
              <Link 
                to="/signup"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </header>


      {/* Hero Section */}
      <section className="relative pb-16 overflow-hidden bg-gradient-to-br from-purple-50 via-white to-red-50">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob-enhanced"></div>
          <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-red-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob-enhanced animation-delay-2000"></div>
        </div>
        
        <div className={`relative z-10 text-center px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="max-w-4xl mx-auto">
            <div className="mb-6 inline-flex items-center space-x-2 bg-white/70 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 shadow-sm">
              <span className="w-4 h-4 text-red-600">🚫</span>
              <span className="text-sm text-gray-700 font-medium">No Cancellation After Purchase</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-thin text-gray-900 mb-6 leading-tight">
              Cancellation
              <br />
              <span className="bg-gradient-to-r from-purple-600 to-red-600 bg-clip-text text-transparent font-light">
                Policy
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto font-light leading-relaxed">
              Important information about our no-cancellation policy for purchased residency program access
            </p>

            {/* Alert Banner */}
            <div className="max-w-3xl mx-auto bg-red-50 border-2 border-red-200 rounded-2xl p-6 shadow-sm">
              <div className="flex items-center justify-center space-x-3">
                <div className="text-2xl">🛑</div>
                <div className="text-left">
                  <h3 className="text-lg font-semibold text-red-800">No Cancellations After Purchase</h3>
                  <p className="text-red-700 text-sm">
                    Once you purchase access to our residency program list, the subscription cannot be cancelled or refunded.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            {/* Policy Statement */}
            <div className="bg-gradient-to-r from-red-50 to-purple-50 rounded-3xl p-8 mb-12 border-2 border-red-200">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                <span className="mr-3 text-3xl">🚫</span>
                No Cancellation Policy
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                <strong>All purchases are final and cannot be cancelled once payment is processed.</strong> 
                Due to the immediate access provided to our comprehensive residency program database, 
                including familiarity scores, Step 2 CK cutoffs, and premium features, we do not allow 
                cancellations after purchase.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-0">
                By completing your purchase, you acknowledge and agree to this no-cancellation policy.
              </p>
            </div>

            {/* Why This Policy Exists */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">🔒</span>
                Why We Have This Policy
              </h2>
              
              <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  Our platform provides instant access to valuable, proprietary medical residency data 
                  that has been carefully compiled, analyzed, and made immediately available upon purchase. 
                  The digital nature of our products means they cannot be "returned" once accessed.
                </p>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Upon purchase, you immediately gain access to:</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-purple-600 mr-3 mt-1">•</span>
                    <span><strong>Complete Program Database:</strong> Access to 600+ residency program profiles with detailed information</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-600 mr-3 mt-1">•</span>
                    <span><strong>Personalized Familiarity Scores:</strong> Custom compatibility ratings based on your profile</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-600 mr-3 mt-1">•</span>
                    <span><strong>Step 2 CK Cutoff Data:</strong> Exclusive score requirements for all programs</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-600 mr-3 mt-1">•</span>
                    <span><strong>Advanced Filtering System:</strong> Smart search tools for program selection</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-600 mr-3 mt-1">•</span>
                    <span><strong>Visa Sponsorship Information:</strong> Detailed H1B and J1 sponsorship data</span>
                  </li>
                </ul>

                <div className="mt-6 p-4 bg-purple-50 rounded-xl border border-purple-200">
                  <p className="text-purple-800 text-sm mb-0">
                    <strong>Instant Delivery:</strong> Since our services are digital and delivered immediately 
                    upon payment, all sales are considered final with no possibility of cancellation.
                  </p>
                </div>
              </div>
            </div>

            {/* What This Means */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">📋</span>
                What This Means for You
              </h2>
              
              <div className="space-y-6">
                <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-8 shadow-sm">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                    <span className="text-yellow-600 mr-2">⚠️</span>
                    Before You Purchase
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Please carefully consider your purchase decision as it cannot be reversed. Make sure you:
                  </p>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-yellow-600 mr-3 mt-1">✓</span>
                      <span>Understand exactly what features are included in your chosen plan</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-600 mr-3 mt-1">✓</span>
                      <span>Have reviewed our pricing and feature comparison thoroughly</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-600 mr-3 mt-1">✓</span>
                      <span>Are ready to use the platform for your residency applications</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-600 mr-3 mt-1">✓</span>
                      <span>Have contacted support with any pre-purchase questions</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-red-50 border border-red-200 rounded-2xl p-8 shadow-sm">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                    <span className="text-red-600 mr-2">🚫</span>
                    After Purchase
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Once your payment is processed, the following apply:
                  </p>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">×</span>
                      <span>No cancellations will be accepted for any reason</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">×</span>
                      <span>No refunds will be processed regardless of usage</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">×</span>
                      <span>No exceptions for change of mind or circumstances</span>
                    </li>
                    <li className="flex items-start">
                      <span class="text-red-600 mr-3 mt-1">×</span>
                      <span>No partial refunds for unused features or time</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Account Access */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">🔐</span>
                Account Access & Duration
              </h2>
              
              <div className="bg-blue-50 border border-blue-200 rounded-2xl p-8 shadow-sm">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">What You Get Permanently</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Since cancellations are not available, your purchase provides you with:
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white rounded-xl p-6 border border-blue-200">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <span className="text-blue-600 mr-2">✅</span>
                      Permanent Access
                    </h4>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Lifetime access to purchased features</li>
                      <li>• All program data and scores</li>
                      <li>• Account profile preservation</li>
                      <li>• Historical data retention</li>
                    </ul>
                  </div>
                  
                  <div className="bg-white rounded-xl p-6 border border-blue-200">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <span className="text-blue-600 mr-2">🔄</span>
                      Ongoing Updates
                    </h4>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Regular database updates</li>
                      <li>• New program additions</li>
                      <li>• Feature improvements</li>
                      <li>• System enhancements</li>
                    </ul>
                  </div>
                </div>

                <div className="mt-6 p-4 bg-blue-100 rounded-xl border border-blue-300">
                  <p className="text-blue-800 text-sm mb-0">
                    <strong>Value Protection:</strong> Since you cannot cancel, we ensure you receive 
                    ongoing value through continuous updates and improvements to the platform.
                  </p>
                </div>
              </div>
            </div>

            {/* Technical Issues */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">🛠️</span>
                Technical Issues & Support
              </h2>
              
              <div className="bg-green-50 border border-green-200 rounded-2xl p-8 shadow-sm">
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  While we cannot offer cancellations, we are committed to ensuring you can 
                  access and use all the features you've purchased. If you experience technical issues:
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <span className="text-green-600 mr-2">🔧</span>
                      We Will Help With:
                    </h3>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Platform access problems</li>
                      <li>• Feature functionality issues</li>
                      <li>• Data loading or display errors</li>
                      <li>• Account setup difficulties</li>
                      <li>• Performance optimization</li>
                      <li>• Browser compatibility issues</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <span className="text-green-600 mr-2">🎯</span>
                      Our Commitment:
                    </h3>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• 4-6 hour response time</li>
                      <li>• Dedicated technical support</li>
                      <li>• Step-by-step troubleshooting</li>
                      <li>• Platform training sessions</li>
                      <li>• Feature usage guidance</li>
                      <li>• Ongoing assistance</li>
                    </ul>
                  </div>
                </div>

                <div className="mt-6 p-4 bg-white rounded-xl border border-green-200">
                  <p className="text-green-800 text-sm mb-0">
                    <strong>Our Promise:</strong> We will work with you to resolve any technical issues 
                    and ensure you can fully utilize all purchased features.
                  </p>
                </div>
              </div>
            </div>

            {/* Legal Framework */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">📜</span>
                Legal Framework
              </h2>
              
              <div className="space-y-6">
                <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Consumer Rights</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    This policy is designed to be fair and transparent while protecting our digital intellectual property. 
                    We operate under Indian consumer protection laws and regulations.
                  </p>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-gray-600 mr-3 mt-1">•</span>
                      <span>All terms are clearly disclosed before purchase</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-gray-600 mr-3 mt-1">•</span>
                      <span>Pricing and features are transparent and detailed</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-gray-600 mr-3 mt-1">•</span>
                      <span>Support is provided for all technical issues</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-gray-600 mr-3 mt-1">•</span>
                      <span>Ongoing service improvements and updates are included</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-orange-50 border border-orange-200 rounded-2xl p-8 shadow-sm">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                    <span className="text-orange-600 mr-2">⚖️</span>
                    Governing Law
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-0">
                    This cancellation policy is governed by Indian law and is part of our Terms of Service. 
                    By making a purchase, you agree to the jurisdiction of courts in New Delhi, India for 
                    any disputes related to this policy. The policy is operated by Revio Education Private Limited.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact for Clarification */}
            <div className="mb-12">
              <h2 className="text-3xl font-thin text-gray-900 mb-6 flex items-center">
                <span className="mr-4 text-4xl">📞</span>
                Questions About This Policy?
              </h2>
              
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8 border border-gray-200">
                <p className="text-lg text-gray-700 mb-6">
                  If you have questions about our cancellation policy or need clarification before making a purchase, 
                  please contact our support team. We want you to make an informed decision.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email Support</h3>
                      <a href="mailto:info@revisableapp.com" className="text-blue-600 hover:text-blue-700">
                        info@revisableapp.com
                      </a>
                      <p className="text-gray-600 text-sm">Response within 4-6 hours</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.512z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">WhatsApp Support</h3>
                      <a href="https://wa.me/919650500689" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700">
                        +91 96505 00689
                      </a>
                      <p className="text-gray-600 text-sm">Instant messaging</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 text-center">
                  <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Pre-Purchase Consultation</h4>
                    <p className="text-gray-700 text-sm mb-4">
                      Not sure if our platform is right for you? Schedule a free consultation to discuss 
                      your residency matching needs and learn about our features before making a commitment.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                      <a
                        href="mailto:info@revisableapp.com?subject=Pre-Purchase Consultation Request"
                        className="bg-blue-600 text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:bg-blue-700 hover:scale-105 shadow-lg"
                      >
                        Request Consultation
                      </a>
                      <Link
                        to="/features"
                        className="border-2 border-blue-600 text-blue-600 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:bg-blue-600 hover:text-white"
                      >
                        View All Features
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Final Reminder */}
            <div className="mb-12">
              <div className="bg-gradient-to-r from-red-100 to-purple-100 rounded-3xl p-8 border-2 border-red-300 shadow-lg">
                <div className="text-center">
                  <div className="text-4xl mb-4">⚠️</div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Important Reminder</h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    <strong>Please read this entire policy carefully before making your purchase.</strong>
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    By clicking "Purchase" or "Buy Now" on our platform, you acknowledge that you have 
                    read, understood, and agree to this no-cancellation policy. All sales are final, 
                    and no cancellations or refunds will be processed after payment.
                  </p>
                  <div className="bg-white rounded-2xl p-4 border border-red-200 max-w-md mx-auto">
                    <p className="text-red-800 text-sm font-medium mb-0">
                      ✓ I understand this is a final sale<br/>
                      ✓ I cannot cancel after purchase<br/>
                      ✓ I will receive permanent access to purchased features
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Related Links */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-2xl font-thin text-gray-900 mb-8 text-center">Related Policies</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link
              to="/refund-policy"
              className="bg-white border border-gray-200 rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="text-3xl mb-4">💰</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Refund Policy</h3>
              <p className="text-gray-600 text-sm">Learn about our no-refund policy</p>
            </Link>
            
            <Link
              to="/terms"
              className="bg-white border border-gray-200 rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="text-3xl mb-4">📋</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Terms of Service</h3>
              <p className="text-gray-600 text-sm">Read our full terms and conditions</p>
            </Link>
            
            <Link
              to="/help"
              className="bg-white border border-gray-200 rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="text-3xl mb-4">❓</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Help Center</h3>
              <p className="text-gray-600 text-sm">Find answers to common questions</p>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-6">
                <img 
                  src="/images/logo.png" 
                  alt="Residency Companion Logo" 
                  className="w-12 h-12 mr-4 object-contain"
                />
                <div>
                  <h4 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
                    Residency Companion
                  </h4>
                  <p className="text-sm text-gray-500 font-medium">IMG Residency Matching Platform</p>
                </div>
              </div>
              <p className="text-gray-600 font-light">
                Your strategic partner in medical residency applications.
              </p>
            </div>
            <div>
              <h5 className="font-semibold text-gray-900 mb-4">Product</h5>
              <ul className="space-y-3 text-gray-600">
                <li><Link to="/features" className="hover:text-blue-600 transition-colors">Features</Link></li>
                <li><Link to="/how-it-works" className="hover:text-blue-600 transition-colors">How It Works</Link></li>
                <li><Link to="/api" className="hover:text-blue-600 transition-colors">API</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-semibold text-gray-900 mb-4">Support</h5>
              <ul className="space-y-3 text-gray-600">
                <li><Link to="/help" className="hover:text-blue-600 transition-colors">Help Center</Link></li>
                <li><Link to="/contact" className="hover:text-blue-600 transition-colors">Contact Us</Link></li>
                <li><Link to="/refund-policy" className="hover:text-blue-600 transition-colors">Refund Policy</Link></li>
                <li><Link to="/cancellation-policy" className="text-blue-600 font-medium">Cancellation Policy</Link></li>
                <li><Link to="/privacy" className="hover:text-blue-600 transition-colors">Privacy</Link></li>
                <li><Link to="/terms" className="hover:text-blue-600 transition-colors">Terms</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-semibold text-gray-900 mb-4">Company</h5>
              <ul className="space-y-3 text-gray-600">
                <li><Link to="/about" className="hover:text-blue-600 transition-colors">About</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-12 pt-8 text-center">
            <p className="text-gray-500 text-sm">
              © 2025 Revio Education Pvt Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes blob-enhanced {
          0% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
          25% { transform: translate(20px, -30px) scale(1.05) rotate(5deg); }
          50% { transform: translate(-15px, 10px) scale(0.95) rotate(-3deg); }
          75% { transform: translate(25px, -20px) scale(1.08) rotate(7deg); }
          100% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
        }
        .animate-blob-enhanced { animation: blob-enhanced 9s ease-in-out infinite; }
        .animation-delay-2000 { animation-delay: 2s; }
      `}</style>
    </div>
  );
};

export default CancellationPolicyPage;